import { api } from "@/api";
import { virtualStreamPath } from "./virtualSportType";

export interface VirtualRoundMatch {
  matchId: number;
  home: string;
  away: string;
  homeUid: number; // VFL team uid (= logo teamid); 0 if absent
  awayUid: number;
  score: string | null; // "H:A" (live FT or final)
  htScore: string | null; // "H:A" at half time
  liveStatus: number; // vf_livescore status (100 = full time), 0 if unknown
  win1x2: string | null; // "1" | "X" | "2" once resolved
}

// One VR round's matches (final score + winning 1X2) for the week-results view.
export const getVirtualRound = async (
  leagueId: number,
  round: number
): Promise<VirtualRoundMatch[]> => {
  const res = await api.client.get(
    virtualStreamPath("virtual-football", "round"),
    { params: { leagueId, round } }
  );
  return res.data?.matches ?? [];
};
